// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormButtonGroup_wrapper"};